module.exports = __webpack_public_path__ + "img/yellow-save.svg";